'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { Shimmer } from '@/components/ai-elements/shimmer';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';
type ToolLoadingIndicatorProps = {
  message: string;
  className?: string;
  showSpinner?: boolean;
  variant?: 'default' | 'compact';
};
export function ToolLoadingIndicator(t0) {
  const $ = _c(24);
  const {
    message,
    className,
    showSpinner: t1,
    variant: t2
  } = t0;
  const showSpinner = t1 === undefined ? true : t1;
  const variant = t2 === undefined ? "default" : t2;
  if (variant === "compact") {
    let t3;
    if ($[0] !== className) {
      t3 = cn("inline-flex min-w-0 max-w-full items-center gap-2 rounded-md bg-zinc-800 px-2 py-1 text-xs text-muted-foreground", className);
      $[0] = className;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== showSpinner) {
      t4 = showSpinner && <Spinner size="sm" />;
      $[2] = showSpinner;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== message) {
      t5 = <Shimmer className="min-w-0 text-xs text-muted-foreground wrap-anywhere">{message}</Shimmer>;
      $[4] = message;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
      t6 = <div className={t3}>{t4}{t5}</div>;
      $[6] = t3;
      $[7] = t4;
      $[8] = t5;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      y: 5
    };
    t4 = {
      opacity: 1,
      y: 0
    };
    t5 = {
      opacity: 0,
      y: -5
    };
    t6 = {
      duration: 0.2
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
  }
  let t7;
  if ($[14] !== className) {
    t7 = cn("mt-2 flex box-border min-w-0 w-full max-w-full items-center gap-2 overflow-hidden rounded-md border border-border bg-surface p-2 text-xs text-zinc-200", className);
    $[14] = className;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== showSpinner) {
    t8 = showSpinner && <Spinner size="sm" />;
    $[16] = showSpinner;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== message) {
    t9 = <Shimmer className="text-xs">{message}</Shimmer>;
    $[18] = message;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = <motion.div initial={t3} animate={t4} exit={t5} transition={t6} className={t7}>{t8}{t9}</motion.div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}